module.exports = __webpack_public_path__ + "img/wordcloud-endijs-karklins.918ae78d.png";